module.exports = __webpack_public_path__ + "static/media/pic4.fd310a79.jpg";